import React from 'react'

function Contact() {
  return (
    <div name="contact" className='w-full h-screen bg-gradient-to-b from-black
    to-gray-800 text-white p-4'>
        <div className='flex flex-col justify-center max-w-screen-lg
        mx-auto h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline
                border-b-4 border-gray-500'>Contact</p>
                <p className='py-6'>Submit the form below to get in touch.</p>
            </div>

            <div className='flex justify-center items-center'>
                <form 
                method='POST'
                action='https://getform.io/f/60a7f2de-84ad-455e-9dcd-28feb5b697ae' 
                className='flex flex-col w-full
                md:w-1/2'>
                    <input 
                    type="text"
                    name="name"
                    placeholder='Enter your name...'
                    className='p-2 bg-transparent border-2 
                    rounded-md text-white focus:outline-none'
                    />

                    <input 
                    type="email"
                    name="email"
                    placeholder='Enter your mail...'
                    className='my-4 p-2 bg-transparent border-2 
                    rounded-md text-white focus:outline-none'
                    />

                    <textarea
                    name='message'
                    placeholder='Enter your message...'
                    rows='10'
                    className='p-2 bg-transparent border-2 
                    rounded-md text-white focus:outline-none'>
                    </textarea>

                    <button className='text-white bg-gradient-to-b
                    from-cyan-500 to-blue-500 px-6 py-3 my-8
                    mx-auto flex items-center rounded-md hover:scale-105 duration-300'>
                        Let's Talk
                    </button>
                </form>
            </div>
        </div>
    </div>
  )
}

export default Contact